import React, { useEffect, useState } from 'react';
import { Play } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { publicPromoVideo } from '../lib/api';
import { useT } from '../lib/i18n';

const toMedia = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return { type: 'iframe', src: `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0` };
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return { type: 'iframe', src: `https://player.vimeo.com/video/${vm[1]}?autoplay=1` };
  return { type: 'file', src: url };
};

export const PromoVideo = () => {
  const { t } = useT();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    publicPromoVideo().then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.enabled || !data.url) return null;
  const media = toMedia(data.url);

  return (
    <>
      <div className="relative flex items-center">
        <Button
          onClick={() => setOpen(true)}
          data-testid="watch-film-btn"
          variant="outline"
          className="bg-transparent border-2 border-rich-green text-dark-green hover:bg-rich-green hover:text-cream px-12 py-7 text-lg rounded-none transition-all duration-300 hover:scale-105 font-semibold tracking-wider"
        >
          <Play className="mr-2" size={18} fill="currentColor" />
          {t('home.watchFilm')}
        </Button>
        {data.caption && (
          <span
            data-testid="promo-video-caption"
            className="absolute top-full left-1/2 -translate-x-1/2 mt-3 whitespace-nowrap text-charcoal/70 text-sm italic tracking-wide"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            {data.caption}
          </span>
        )}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl w-[92vw] bg-dark-green border-2 border-gold p-0 overflow-hidden" data-testid="promo-video-modal">
          <DialogTitle className="sr-only">{t('home.watchFilm')}</DialogTitle>
          <div className="relative w-full bg-black" style={{ aspectRatio: '16 / 9' }}>
            {open && (media.type === 'iframe' ? (
              <iframe
                src={media.src}
                className="absolute inset-0 w-full h-full"
                allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                allowFullScreen
                title="The Chimera Gallery — Film"
              />
            ) : (
              <video src={media.src} className="absolute inset-0 w-full h-full" controls autoPlay playsInline />
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PromoVideo;
